<template>
    <div class="csv-upload__content-wrapper__need-help">
            <h4 class="title-s">Need Help With Your CSV Upload?</h4>
            <div class="cta-wrapper">
                <a class="instruction-link" v-if="instructionsUrl" :href="instructionsUrl" target="_blank"><span class="title-s" aria-label="See instructions"><SeeInstructions role="presentation" />See Instructions</span></a>
                <!-- <span @click="openYoutubeVideo" class="title-s" aria-label="See video" ><img src="@icons/see-video.svg" role="presentation">See Video</span>-->
                <span style="cursor: pointer" v-else @click="openLiveChat({sessionStarted: false, hideLauncher: true})" class="title-s" aria-label="Chat with us"><ChatWithUs role="presentation" />Chat With Us</span> 
            </div>
    </div>

</template>

<script setup lang="ts">
    import { ref, computed } from "vue";
    import { usePage } from "@inertiajs/vue3";
    import useLiveChat from "@composables/useLiveChat";
    import SeeInstructions from "@icons/see-instructions.svg";
    import ChatWithUs from "@icons/chat-with-us.svg";
    let instructionsUrl = computed(()=>{
        return usePage().props.instructionsUrl;
    })

    let { openLiveChat } = useLiveChat();
 
</script>
